// A spinner with an accessible label. Screen readers announce
// "Loading employees…" (or whatever the parent provides) when this
// shows up. Visually identical to a bare <Spinner /> — the parent
// gets to decide padding via className.

import { Spinner } from '@ng-unifi/ui';

export interface LoadingStateProps {
  /** What's loading, e.g. "Loading employees…". */
  label?: string;
  /** Wrapper className — pad as the layout demands. */
  className?: string;
}

export function LoadingState({
  label = 'Loading…',
  className = 'p-12 flex justify-center',
}: LoadingStateProps) {
  return (
    <div role="status" aria-live="polite" className={className}>
      <Spinner />
      <span className="sr-only">{label}</span>
    </div>
  );
}
